import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { signInWithEmailAndPassword } from "firebase/auth";
import { auth } from "../firebase";
import "../App.css";
import TopNav from "../components/TopNav";
import showEye from "../assets/img/show_eye.png";
import hideEye from "../assets/img/hide_eye.png";

function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setErrorMsg("");
    try {
      await signInWithEmailAndPassword(auth, email, password);
      navigate("/");
    } catch (err) {
      const errorCode = err.code;
      if (errorCode === "auth/user-not-found") {
        setErrorMsg("This email is not registered.");
      } else if (errorCode === "auth/wrong-password") {
        setErrorMsg("The password you entered is incorrect.");
      } else {
        setErrorMsg("Login failed. Please try again.");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <TopNav />

      <div className="login_section">

        
        <h1 className="auth-heading">Login to WorkMart</h1>
        <p className="auth-subtext">
          Enter your email and password to continue
        </p>

        <form onSubmit={handleLogin} className="auth-form">
          <input
            type="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />

          <div className="password-field">
            <input
              type={showPassword ? "text" : "password"}
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
            <img
              src={showPassword ? hideEye : showEye}
              alt={showPassword ? "Hide password" : "Show password"}
              className="toggle-password"
              onClick={() => setShowPassword(!showPassword)}
            />
          </div>

          {errorMsg && <p className="error-text">{errorMsg}</p>}

          <button className="auth-btn login_btn" type="submit" disabled={loading}>
            {loading ? <span className="loader"></span> : "Login"}
          </button>
        </form>

        <p className="auth-link">
          Don’t have an account?{" "}
          <span className="auth-link-btn" onClick={() => navigate("/register")}>
            Register Page
          </span>
        </p>
      </div>
    </div>
  );
}

export default Login;
